import { MAX_BATCHES_PER_FIELD_COUNT } from '@core/core/store'
import type { PageDestination, PaginationInfo } from '@core/core/types'
import type { Nullable } from 'common/types'
import { useEffect, useState } from 'react'

export const useScrollPagingControl = (
  pager: (page: PageDestination) => void,
  pagingInfo?: PaginationInfo,
) => {
  const [currentEl, setCurrentEl] = useState<Nullable<HTMLDivElement>>(null)

  const pageCount = pagingInfo?.pageCount ?? 0
  const currentPage = pagingInfo?.page.page ?? 0
  const prevPage = pagingInfo?.prevPage.page ?? 0

  // Листание страниц по колесику
  useEffect(() => {
    const updatePage = (e: WheelEvent) => {
      if (currentEl && pageCount > 1) {
        const wheelMovedDown = e.deltaY > 0
        const wheelMovedUp = e.deltaY < 0
        const isScrolledToBottom =
          currentEl.scrollHeight - currentEl.scrollTop === currentEl.clientHeight
        const isScrolledToTop = currentEl.scrollTop === 0

        if (wheelMovedDown && isScrolledToBottom && currentPage < pageCount) {
          currentEl.removeEventListener('wheel', updatePage)
          pager('next')
        } else if (wheelMovedUp && isScrolledToTop && currentPage > MAX_BATCHES_PER_FIELD_COUNT) {
          currentEl.removeEventListener('wheel', updatePage)
          pager('prev')
        }
      }
    }

    currentEl?.addEventListener('wheel', updatePage)
    return () => currentEl?.removeEventListener('wheel', updatePage)
  }, [currentEl, currentPage, pageCount, pager])

  // Скрол к позиции предыдущей страницы при перехлесте страниц
  useEffect(() => {
    if (currentEl && currentPage !== prevPage && currentPage > 1) {
      if (currentPage > prevPage) {
        if (currentPage === 2) {
          currentEl.scrollTo({ top: currentEl.scrollHeight / 2 - currentEl.clientHeight })
        } else if (currentPage > 2) {
          currentEl.scrollTo({ top: currentEl.scrollHeight / 1.5 - currentEl.clientHeight })
        }
      } else if (currentPage >= MAX_BATCHES_PER_FIELD_COUNT) {
        currentEl.scrollTo({ top: currentEl.scrollHeight / 3 })
      }
    }
  }, [currentEl, currentPage, prevPage])

  return setCurrentEl
}
